

<template>
    <BModal :model-value="modal" scrollable size="lg" centered title="Guest" @update:modelValue="updateModal" >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Detail Program</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
                >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <h5>Not Implemented Yet</h5>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <!-- <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton> -->
                <BButton :disabled="tabIndex > 0 ? false : true" variant="secondary" @click="tabIndex--"  class="mr-2">Prev</BButton>
                <BButton v-if="tabIndex !== 5 " variant="primary" @click="tabIndex++"  class="mr-2">Next</BButton>
                <BButton v-if="tabIndex === 5 " variant="primary"  class="mr-2">Save</BButton>
                
            </div>
        </template>
    </BModal>
</template>

<script >     
import { BModal, BButton, } from 'bootstrap-vue-next';
// import { ref, reactive} from 'vue'


export default{
    name : 'DriverGuideForm',
    props : {
        modal: Boolean,
    },
    components : {
        BModal, BButton
    },
    emits: ["update:modal"],
    setup(props, {emit}){
       
        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };
        return {
            updateModal
            
        }
    }
}


</script>

